import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @author Jackie
 * @filename Providers
 * @description Provider
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ConfigProvider, message, App as AntdApp } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import "dayjs/locale/vi"; // ES6 模块
import "dayjs/locale/zh-cn"; // ES6 模块
import dayjs from "dayjs";
export default function Providers({ children }) {
    const { i18n } = useTranslation(); // 国际化
    useEffect(() => {
        if (i18n?.language === "en") {
            dayjs.locale("en-us");
        }
        else if (i18n?.language === "vi") {
            dayjs.locale("vi");
        }
        else {
            dayjs.locale("zh-cn");
        }
    }, [i18n]);
    // 组件尺寸
    const sizeToken = {
        controlHeight: 44,
        controlHeightSM: 40,
        controlHeightXS: 48,
    };
    // 配置全局消息提示
    message.config({
        maxCount: 1,
    });
    return (_jsx(ConfigProvider, { locale: i18n?.language === "en" ? enUS : i18n?.language === "vi" ? viVN : zhCN, prefixCls: "bossvn", theme: {
            token: {
                colorPrimary: "#5a7cff",
                // borderRadius: 12,
                fontFamily: "Inter, system-ui, sans-serif",
                lineHeight: 1.5,
                colorBorder: "#ECEEF0",
                colorBgSpotlight: "rgba(255,255,255,1)",
                colorTextPlaceholder: "#BFBFBF",
                colorTextDescription: "#BFBFBF",
            },
            components: {
                Segmented: {
                    itemActiveBg: "#577CF6",
                    itemSelectedBg: "#577CF6",
                    itemColor: "#333",
                    itemSelectedColor: "#fff",
                    trackPadding: "0",
                },
                Button: {
                    controlHeight: 32,
                    borderRadius: 12,
                    paddingInline: 18,
                    contentFontSize: 16,
                    boxShadow: "none",
                    boxShadowSecondary: "none",
                    defaultShadow: "none",
                    primaryShadow: "none",
                    dangerShadow: "none",
                    colorPrimaryHover: "#3D68F4",
                    ...sizeToken,
                },
                Divider: {
                    marginLG: 18,
                    margin: 18,
                    marginSM: 18,
                },
                Radio: {
                    ...sizeToken,
                    borderRadius: 12,
                },
                Tag: {
                    fontSize: 12,
                    fontSizeSM: 12,
                    fontSizeLG: 12,
                    fontSizeXL: 12,
                    colorBorder: "#ECEEF0",
                    defaultBg: "#F8F9FA",
                    marginXS: 12,
                },
                Input: {
                    borderRadius: 12,
                    paddingInline: 12,
                    fontSize: 14,
                    ...sizeToken,
                    borderRadiusLG: 12,
                    borderRadiusSM: 12,
                    borderRadiusXS: 12,
                    colorTextPlaceholder: "#BFBFBF",
                    // 修改showCount的颜色
                    colorTextQuaternary: "#BFBFBF", // 设置字符计数器的颜色
                    colorTextDescription: "#BFBFBF",
                },
                Select: {
                    controlHeight: 32,
                    borderRadius: 12,
                    fontSize: 14,
                    colorBorder: "#ECEEF0",
                    ...sizeToken,
                },
                Pagination: {
                    borderRadius: 8,
                    itemActiveBg: "#577CF6",
                },
                Form: {
                    labelColor: "#333",
                    labelFontSize: 16,
                    labelHeight: 24,
                },
                Modal: {
                    titleFontSize: 18,
                    titleColor: "#333",
                    borderRadiusLG: 16,
                },
                DatePicker: {
                    borderRadius: 12,
                    paddingInline: 12,
                    fontSize: 14,
                    ...sizeToken,
                },
            },
            cssVar: true, // 启用CSS变量
        }, children: _jsx(AntdApp, { children: children }) }));
}
